export {default} from './ClientInformation.connect';
